import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Day, DayProps } from 'react-native-gifted-chat';
import { TYPOGRAPHY } from '@/styles';

export const ChatDay: React.FC<DayProps> = (props) => {
  const [styles] = useStyles();
  return <Day {...props} textStyle={[TYPOGRAPHY.p, styles.base]} />;
};

const useStyles = createStyles((theme) => ({
  base: {
    color: theme.colors.primary,
    fontSize: theme.fontSizes.xsmall,
    fontWeight: 'normal',
  },
}));
